import React from 'react';

const ServerPromoCard = ({ variant = 'default' }) => {
  return (
    <div className="bg-gradient-to-br from-yellow-400/5 to-yellow-600/5 rounded-3xl p-8 border border-yellow-400/20 relative overflow-hidden">
      {/* Decorative shapes */}
      <div className="absolute -top-10 -right-10 w-40 h-40 bg-yellow-400/10 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-yellow-600/10 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/4 w-20 h-20 bg-yellow-500/5 rotate-45 blur-xl"></div>
      
      <div className="relative z-10 flex flex-col md:flex-row items-center gap-6">
        <div className="flex-shrink-0">
          <div className="w-20 h-20 bg-gray-800 rounded-2xl flex items-center justify-center">
            <i className="fas fa-server text-4xl text-yellow-400"></i>
          </div>
        </div>
        
        <div className="flex-1 text-center md:text-left">
          <h3 className="text-2xl font-bold text-white mb-2">
            Besoin d'un serveur de jeu ?
          </h3>
          <p className="text-gray-400 text-base">
            Profitez de nos serveurs haute performance pour Minecraft, FiveM, ARK et bien plus. 
            Protection DDoS incluse, support 24/7 et démarrage instantané.
          </p>
        </div>
        
        <div className="flex-shrink-0">
          <a
            href="https://sunserv.fr/shop"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-gray-900 font-bold px-8 py-3 rounded-xl transition-all hover:scale-105"
          >
            <span>Découvrir nos offres</span>
            <i className="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ServerPromoCard;
